export default __webpack_public_path__ + "static/media/IconDownArrow.aa6622f7.svg";